<template>
<v-dialog v-model="dialog" max-width="1000px">
	<v-card class="elevation-12">
		<v-toolbar
			color="primary"
			dark
			flat>
			<v-toolbar-title>Select Enrolled Students</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            label="Search"
            prepend-icon="mdi-magnify"
            v-model="searchTerm"
            autocomplete="off"/>
        </v-col>

        <v-col cols="12" md="3">
          <v-menu
            ref="DateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Select Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                hint="Select 2 dates">
              </v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              scrollable
              range
              @change="refresh()">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.DateMenu.save(date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        
        <v-col cols="12" md="2">
          <v-select
            v-model="selectedCourseType"
            @change="getCourses"
            :items="courseTypes"
            item-text="title"
            item-value="id"
            label="Type">
          </v-select>
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            v-model="selectedCourse"
            @change="refresh"
            :items="courses"
            item-text="title"
            item-value="id"
            label="Course">
          </v-select>
        </v-col>

      </v-row>

      <v-data-table
        :headers="headers"
        :items="registrations"
        :loading="loading"
        :search="searchTerm">
      </v-data-table>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn 
				@click="dialog = false">
				Close
			</v-btn>
			<v-btn 
				color="primary"
				@click="selectAll()"
        :disabled="loading || !selectedCourse">
				Select
			</v-btn>

		</v-card-actions>
  </v-card>
	
</v-dialog> 
</template>

<script>
import Moment from 'moment'
import Api from '../../services/api'
import { REGISTRATION_STATUS } from '../../services/constants'
import CourseMixin from '../../mixins/course.mixin'
import DataTableMixin from '../../mixins/data-table.mixin'

export default {
  name: 'StudetSelector',
  mixins: [ CourseMixin, DataTableMixin ],
  data() {
    return {
      loading: false,
      dialog: false,
      dateMenu: false,
      date: [],
      registrations: [],
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Lastname', value: 'lastname', align: 'start' },
        { text: 'Firstname', value: 'firstname' },
        { text: 'Middlename', value: 'middlename' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Email', value: 'email' },
      ],
      searchTerm: '',
    }
  },
  mounted() {    
    this.date = [
			Moment().subtract(1, 'year').format('YYYY-MM-DD'),
			Moment().startOf('endOf').format('YYYY-MM-DD'),
		];
  },
  methods: {
    init() {
      this.dialog = true;
      this.getCourseTypes();
      this.getCourses();
      this.registrations = [];
      this.selectedCourse = 0;
    },

    selectAll() {
      this.$emit('student-selected', { students: this.registrations } );
      this.dialog = false;
    },

    refresh() {
      if(!this.selectedCourse) {
        return;
      }

      if(this.date.length < 2) {
        return;
      }
      
      this.registrations = [];
      this.loading = true;
      Api.registration.getAll(
          this.date[0], 
          this.date[1],
          this.selectedCourseType,
          0,
          this.selectedCourse,
          REGISTRATION_STATUS.ENROLLED,
        )
        .then((response) => {
          this.registrations = response.data;
        })
        .catch(() => {
          this.registrations = [];
        })
        .finally(() => {
          this.loading = false;
          this.itemsPerPage = (this.selectedCourse)? -1 : 15;
        });
    },

  },
}
</script>